import './ChannelPerformanceTable.scss';
import cn from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

interface PerformanceTableShellProps extends PropsWithChildren {
  className?: string;
  // Rendered under the table, e.g. a row of toggles or a note.
  belowTable?: ReactNode;
}

// The bordered, horizontally scrolling table frame Channel Performance and Market Performance
// share, so the two tables read as one family. Children are the table's own sections.
export const PerformanceTableShell = ({
  className,
  belowTable,
  children
}: PerformanceTableShellProps) => (
  <div className={cn('channel-performance-table', className)}>
    <div className='channel-performance-table-scroll'>
      <table>{children}</table>
    </div>
    {belowTable}
  </div>
);
